<template>
	<BaseCmsPage v-slot="{page}">
		<CmsPageHeader>
			<CmsBreadcrumbs :items="page?.breadcrumbs" />
			<h1 v-if="page?.seo_h1" class="page-title">{{ page.seo_h1 }}</h1>
		</CmsPageHeader>
			
		<CmsTwoColumns>
			<div v-if="page?.content" class="cms-content" v-html="page.content" v-interpolation />

			<template v-if="page?.code == 'webshop_terms' && page?.content_pdf_upload_path">
				<div class="terms">
					<a class="btn btn-download" :href="page.content_pdf_upload_path" target="_blank"><BaseCmsLabel code="download_terms_pdf" /></a>
				</div>
			</template>

			<CmsShare />
		</CmsTwoColumns>
	</BaseCmsPage>
</template>